import { LOCALES } from '../constants';

export default {
  [LOCALES.JAPAN]: {
    'email': 'Eメール',
    'log In': '登録',
    'VerificationCode': 'メールで届いた認証コード',
  },
};
